import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import {
  VerifyCloudflareTurnstileParams,
  verifyCloudflareTurnstileToken,
} from '@utils/backend-api/fraudDetection';

export default function useVerifyCloudflareTurnstile() {
  const { mutate, mutateAsync } = useMutation(
    (params: VerifyCloudflareTurnstileParams) => verifyCloudflareTurnstileToken(params),
    {
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );

  return { mutate, mutateAsync };
}
